import styled, { css } from 'styled-components'

interface IContainer {
  open: boolean
}

export const Container = styled.aside`
  background: #fdfdfd;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  color: ${props => (props.theme.name === 'light' ? '#79858c' : '#eee')};
  transition: 300ms;
  width: ${(props: IContainer) => (props.open ? '260px' : '60px')};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  z-index: 999;
  top: 0;
  left: 0;
  height: 100%;
  a {
    text-decoration: none;
  }
  /* Cabeçalho: rótulo da seção à esquerda e o controle de recolher à direita. */
  button.burger {
    width: 100%;
    min-height: 36px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* Recuo em px, e não em rem: a raiz deste projeto não é 16px, então 1rem deixaria o ícone
       recolhido fora da coluna dos ícones de grupo (que usam 13px + 3px de barra). */
    padding: 8px 16px;
    color: #98a2b3;
    strong {
      font-size: 10px;
      font-weight: 800;
      letter-spacing: 0.13em;
      color: #98a2b3;
      display: ${(props: IContainer) => (props.open ? 'block' : 'none')};
    }
    svg {
      font-size: 20px;
      color: #98a2b3;
    }
    div.bars {
      width: 100%;
      /* Mesma largura do ícone dos itens de grupo, para os dois ficarem no mesmo eixo. */
      max-width: 19px;
      span.bar {
        display: block;
        width: 100%;
        height: 2px;
        background: ${props =>
          props.theme.name === 'light' ? '#79858c' : '#eee'};
      }
      span.bar + span.bar {
        margin-top: 3px;
      }
    }
  }

  /* M5 — campo de busca do menu. */
  .menu_search {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    width: calc(100% - 32px);
    margin: 0 16px 12px;
    padding: 0 10px;
    height: 34px;
    background: #f4f6f9;
    border: 1px solid #edf0f4;
    border-radius: 8px;
    transition: background-color 120ms;
    &:focus-within {
      background: #fff;
      border: 1.5px solid #2f5fa0;
      box-shadow: 0 0 0 3px rgba(47, 95, 160, 0.12);
    }
    .menu_search__icon {
      flex-shrink: 0;
      font-size: 17px;
      color: #98a2b3;
    }
    input {
      flex: 1;
      min-width: 0;
      border: none;
      background: none;
      font-size: 13px;
      color: #344054;
      &:focus {
        outline: none;
      }
      &::placeholder {
        font-size: 13px;
        color: #98a2b3;
      }
    }
    .menu_search__clear {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      padding: 0;
      border: none;
      border-radius: 4px;
      background: none;
      color: #98a2b3;
      cursor: pointer;
      &:hover {
        background: #edf0f4;
      }
      &:focus-visible {
        outline: 2px solid #2f5fa0;
        outline-offset: 1px;
      }
      svg {
        font-size: 16px;
      }
    }
  }

  ${(props: IContainer) =>
    props.open &&
    css`
      .dropdown-menu {
        margin-top: 0.4rem;
        width: 100%;
      }
    `}
  ${(props: IContainer) =>
    !props.open &&
    css`
      /* M2 — recolhido o menu é só o rail: o conteúdo mora no cartão flutuante. */
      overflow: visible;
    `}
  @media screen and (max-width: 650px) {
    position: unset;
    width: 0;
    button.burger {
      position: fixed;
      bottom: 3vh;
      right: 5vw;
      width: 15vw;
      height: 15vw;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
      background-color: ${props => props.theme.colors.primary};
      color: #fff;
      .desc {
        display: none;
      }
      svg {
        color: #fff;
      }
      div.bars {
        margin: 0;
        max-width: 100%;
        span.bar {
          height: 3px;
          width: 100%;
          background-color: #fff;
        }
        span.bar + span.bar {
          margin-top: 6px;
        }
      }
    }
    .menu_search {
      display: none;
    }
    .scroll_menu {
      position: fixed;
      top: 0;
      left: 0;
    }
  }
`
export const ScrollMenu = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  overflow-y: auto;
  @media screen and (max-width: 650px) {
    transform: translateX(0);
    transition: 400ms;
    max-width: 60vw;
    height: 100vh;
    background: #f0f0f0;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    position: fixed;
    top: 0;
    left: 0;
  }

  /* Item navegável: o link ocupa a linha e o alfinete flutua sobre a ponta direita. */
  .menu_item {
    position: relative;
    display: flex;
    align-items: center;
    > a {
      flex: 1;
      min-width: 0;
      min-height: 36px;
      display: flex;
      align-items: center;
      gap: 10px;
      /* À direita fica reservada a faixa do alfinete (right: 10px + 22px de botão): sem isso um
         título longo passa por baixo dele. */
      padding: 8px 38px 8px 16px;
      font-size: 13.5px;
      font-weight: 400;
      color: #5b6b7f;
      transition: background-color 120ms;
      &:hover {
        background: #f7f9fc;
      }
      &:focus-visible {
        outline: 2px solid #2f5fa0;
        outline-offset: -2px;
      }
    }
    .menu_item__title {
      /* min-width auto é o padrão de um item flex e impede o encolhimento — sem o zero aqui o
         texto não trunca, ele transborda. */
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &.is-active > a {
      color: #1b56a3;
      font-weight: 700;
    }
    /* M5 — trecho que casou com o texto buscado. */
    mark {
      padding: 0;
      background: #fdf0d0;
      color: #101828;
      font-weight: 800;
    }
  }

  /* Alfinete: aparece no hover, no foco por teclado e sempre que o item já está fixado. */
  .menu_item__pin {
    position: absolute;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    padding: 0;
    border: none;
    border-radius: 4px;
    background: none;
    color: #c3cad4;
    opacity: 0;
    cursor: pointer;
    transition: background-color 120ms;
    svg {
      font-size: 17px;
    }
    &:hover {
      background: #edf0f4;
    }
    &:focus-visible {
      outline: 2px solid #2f5fa0;
      outline-offset: 1px;
      opacity: 1;
    }
    &.is-pinned {
      color: #f5a623;
      opacity: 1;
    }
  }
  .menu_item:hover .menu_item__pin {
    opacity: 1;
  }

  /* M4 — FIXADOS e RECENTES. */
  .menu_shortcuts {
    display: flex;
    flex-direction: column;
    .menu_shortcuts__label {
      padding: 6px 16px;
      font-size: 9.5px;
      font-weight: 800;
      letter-spacing: 0.1em;
      color: #b0b7c3;
    }
    /* O rótulo de RECENTES também é o controle que recolhe a seção. */
    .menu_shortcuts__toggle {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 0 16px 0 0;
      border: none;
      background: none;
      transition: background-color 120ms;
      .menu_shortcuts__label {
        flex: 1;
        text-align: left;
      }
      svg {
        font-size: 16px;
        color: #b0b7c3;
      }
      &:hover {
        background: #f7f9fc;
      }
      &:focus-visible {
        outline: 2px solid #2f5fa0;
        outline-offset: -2px;
      }
    }
    .menu_shortcuts__divider {
      height: 1px;
      margin: 10px 16px;
      background: #f0f2f5;
    }
    .menu_item__icon {
      flex-shrink: 0;
      font-size: 17px;
    }
    .is-pinned-item {
      > a {
        font-weight: 600;
        color: #344054;
      }
      /* A mãozinha só aparece com o botão pressionado: em repouso o item é um link como os
         outros, e um cursor de arraste permanente sugeriria que ele não navega. */
      &:active > a,
      &.is-dragging > a {
        cursor: grabbing;
      }
      /* Enquanto arrasta, o item some de leve e a posição de destino ganha uma linha. */
      &.is-dragging {
        opacity: 0.4;
      }
      &.is-drop-target > a {
        box-shadow: inset 0 2px 0 #1b56a3;
      }
    }
    .is-recent-item > a {
      font-weight: 400;
      color: #5b6b7f;
      .menu_item__icon {
        color: #c3cad4;
      }
    }
  }

  .menu_empty {
    margin: 0;
    padding: 20px 16px;
    text-align: center;
    font-size: 12.5px;
    color: #98a2b3;
  }

  /* Recolhido não há espaço para os subitens: eles voltam quando o menu reabre. A regra mora
     aqui, e não no bloco de recolhido do Container, porque a especificidade do seletor de
     subitens abaixo venceria uma regra escrita lá. */
  .menu-close & > div.drop_container > div.dropdown-options {
    display: none;
  }

  /* M1 — item de grupo. */
  > div.drop_container {
    display: flex;
    flex-direction: column;
    > button.group_toggle {
      width: 100%;
      min-height: 36px;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 10px 16px;
      background: none;
      border: none;
      border-left: 3px solid transparent;
      padding-left: 13px;
      text-align: left;
      transition: background-color 120ms;
      strong {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 13.5px;
        font-weight: 400;
        color: #344054;
      }
      svg {
        flex-shrink: 0;
        font-size: 19px;
        color: #7b8794;
      }
      .arrow {
        margin-left: auto;
        display: flex;
        align-items: center;
        svg {
          font-size: 18px;
          color: #b0b7c3;
        }
      }
      mark {
        padding: 0;
        background: #fdf0d0;
        color: #101828;
        font-weight: 800;
      }
      &:hover {
        background: #f7f9fc;
      }
      &:focus-visible {
        outline: 2px solid #2f5fa0;
        outline-offset: -2px;
      }
      /* Grupo da tela aberta: a barra à esquerda entra no lugar dos 3px de padding, então o
         conteúdo não desloca ao ficar ativo. */
      &.is-active {
        background: #eaf1fa;
        border-left-color: #1b56a3;
        strong {
          color: #0d2b59;
          font-weight: 700;
        }
        > svg {
          color: #1b56a3;
        }
        .arrow svg {
          color: #1b56a3;
        }
      }
    }
    /* M1 — subitens recuados, ligados ao grupo por uma guia vertical. */
    > div.dropdown-options {
      display: flex;
      flex-direction: column;
      padding: 4px 0 8px 32px;
      border-left: none;
      background: none;
      .menu_item {
        border-left: 1px solid #dbe3ec;
        > a {
          padding: 8px 38px 8px 14px;
        }
      }
      .dropdown {
        border-left: 1px solid #dbe3ec;
        > button.dropdown-toggle {
          width: 100%;
          min-height: 36px;
          display: flex;
          align-items: center;
          padding: 8px 16px 8px 14px;
          font-size: 13.5px;
          font-weight: 400;
          color: #5b6b7f;
          text-align: left;
          transition: background-color 120ms;
          &:hover {
            background: #f7f9fc;
          }
          &:focus-visible {
            outline: 2px solid #2f5fa0;
            outline-offset: -2px;
          }
          mark {
            padding: 0;
            background: #fdf0d0;
            color: #101828;
            font-weight: 800;
          }
        }
        .dropdown-menu .menu_item {
          border-left: none;
          > a {
            padding: 8px 38px 8px 12px;
          }
        }
      }
    }
  }
`

/* M2 — rail do menu recolhido: zonas de ícones de 60px. */
export const Rail = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 6px 0;
  overflow-y: auto;
  overflow-x: visible;
  background: #fff;
  border-right: 1px solid #eef1f5;

  .rail_divider {
    width: 28px;
    height: 1px;
    margin: 5px auto;
    background: #eef1f5;
    flex-shrink: 0;
  }

  .rail_target {
    position: relative;
    width: 100%;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: none;
    /* A barra do estado ativo entra no lugar do recuo, para o ícone não deslocar. */
    border-left: 3px solid transparent;
    padding-right: 3px;
    background: none;
    flex-shrink: 0;
    transition: background-color 120ms;
    &:hover {
      background: #f7f9fc;
    }
    &:focus-visible {
      outline: 2px solid #2f5fa0;
      outline-offset: -2px;
    }
    /* O destaque é do cartão aberto, não da tela atual — mesma regra do menu expandido. */
    &.is-open {
      background: #eaf1fa;
      border-left-color: #1b56a3;
      .rail_icon,
      .rail_icon svg {
        color: #1b56a3;
      }
    }
    /* Fixados têm identidade própria: aberto, o alfinete fica no amarelo dele. */
    &.is-pinned-target.is-open {
      background: #fdf0d0;
      border-left-color: #f5a623;
      .rail_icon,
      .rail_icon svg {
        color: #f5a623;
      }
    }
  }

  .rail_icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 21px;
    color: #5b6b7f;
    svg {
      font-size: 21px;
      color: #5b6b7f;
    }
    &.is-pinned {
      color: #f5a623;
    }
    &.is-recent {
      color: #98a2b3;
    }
  }

  .rail_burger {
    flex-direction: column;
    gap: 3px;
    width: 19px;
    span {
      display: block;
      width: 100%;
      height: 2px;
      background: #5b6b7f;
    }
  }

  .rail_badge {
    position: absolute;
    top: 6px;
    right: 7px;
    padding: 2px 4px;
    border-radius: 999px;
    background: #f5a623;
    color: #3d2a00;
    font-size: 8.5px;
    font-weight: 800;
    line-height: 1;
  }

  /* Ícone sozinho não se explica: o nome aparece ao lado, e some quando o cartão abre. */
  .rail_tooltip {
    display: none;
    position: fixed;
    left: 68px;
    z-index: 1000000000;
    padding: 7px 10px;
    border-radius: 6px;
    background: #101828;
    color: #fff;
    font-size: 11.5px;
    font-weight: 400;
    white-space: nowrap;
    pointer-events: none;
  }
  .rail_target:hover .rail_tooltip,
  .rail_target:focus-visible .rail_tooltip {
    display: block;
  }
  .rail_target.is-open .rail_tooltip {
    display: none;
  }
`

/* M2 — cartão flutuante único: fixados, grupo, recentes e busca têm a mesma aparência. */
export const FlyoutCard = styled.div`
  position: fixed;
  z-index: 1000000001;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 22px rgba(16, 24, 40, 0.14);
  overflow: hidden;

  .flyout_header {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 11px;
    font-size: 9.5px;
    font-weight: 800;
    letter-spacing: 0.1em;
    color: #b0b7c3;
    background: #fff;
  }
  .flyout_header__pin {
    font-size: 13px;
    color: #f5a623;
  }

  .flyout_search {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 11px 8px;
    padding: 0 8px;
    height: 32px;
    background: #f4f6f9;
    border: 1px solid #edf0f4;
    border-radius: 8px;
    &:focus-within {
      background: #fff;
      border: 1.5px solid #2f5fa0;
      box-shadow: 0 0 0 3px rgba(47, 95, 160, 0.12);
    }
    .flyout_search__icon {
      flex-shrink: 0;
      font-size: 16px;
      color: #98a2b3;
    }
    input {
      flex: 1;
      min-width: 0;
      border: none;
      background: none;
      font-size: 13px;
      color: #344054;
      &:focus {
        outline: none;
      }
      &::placeholder {
        color: #98a2b3;
      }
    }
    button {
      flex-shrink: 0;
      display: flex;
      padding: 0;
      border: none;
      background: none;
      color: #98a2b3;
      cursor: pointer;
      &:focus-visible {
        outline: 2px solid #2f5fa0;
        outline-offset: 1px;
      }
    }
  }

  /* Só a lista rola: o cabeçalho e a busca ficam parados. */
  .flyout_rows {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }

  a {
    display: block;
    padding: 10px 11px;
    border-left: 3px solid #dbe3ec;
    border-top: 1px solid #f4f6f8;
    font-size: 13px;
    font-weight: 400;
    color: #344054;
    text-decoration: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: background-color 120ms;
    &:hover {
      background: #f7f9fc;
      color: #344054;
      text-decoration: none;
    }
    &:focus-visible {
      outline: 2px solid #2f5fa0;
      outline-offset: -2px;
    }
    &.is-active {
      border-left-color: #1b56a3;
      color: #1b56a3;
      font-weight: 700;
    }
    &[draggable='true']:active {
      cursor: grabbing;
    }
    &.is-drop-target {
      box-shadow: inset 0 2px 0 #1b56a3;
    }
  }

  mark {
    padding: 0;
    background: #fdf0d0;
    color: #101828;
    font-weight: 800;
  }

  .flyout_empty {
    margin: 0;
    padding: 20px 11px;
    text-align: center;
    font-size: 12.5px;
    color: #98a2b3;
  }
`
